import { render } from "./ModalSizeForm.vue?vue&type=template&id=7868c90c&scoped=true"
import script from "./ModalSizeForm.vue?vue&type=script&lang=js"
export * from "./ModalSizeForm.vue?vue&type=script&lang=js"

import "./ModalSizeForm.vue?vue&type=style&index=0&id=7868c90c&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7868c90c"]])

export default __exports__